import { Component, OnInit } from '@angular/core';
import { AmorphicService } from '../../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { CoverpathCustomer } from '../../../../../../../coverpath-common/classes/coverpath_subclasses/CoverpathCustomer';
import { Utils } from '../../../../../../../common/js/Utils';
import { FormatterService } from '../../../../../../../coverpath-common/angular/services/formatter/formatter.service';
import { QuoteCardService } from '../quote-card.service';
import { CoverpathUtils } from '../../../../../../../coverpath-common/js/static/CoverpathUtils';
import { SafeInviteInfo } from '../../../../../../../common/js/customer/SafeInviteInfo';
import { Controller } from 'apps/coverpath-client/public/js/Controller';

@Component({
  moduleId: module.id,
  selector: 'whole-life-visualization',
  templateUrl: './whole-life-visualization.component.html',
})
export class WholeLifeVisualizationComponent implements OnInit {
  // Additional advisor properties
  advisorFirstName: string;
  advisorLastName: string;
  advisorStreet: string;
  advisorCity: string;
  advisorState: string;
  advisorZipcode: string;
  advisorPhone: string;
  advisorPhoneLink: string;
  advisorProducerId: string;
  advisorAgencyName: string;
  yearForIllustration: string = CoverpathUtils.getDefaultCurrentRateYear();
  term: string;
  safeInviteInfo: SafeInviteInfo;
  private customer: CoverpathCustomer;
  private controller: Controller;
  private gender: string;
  private dob: Date;

  constructor(
    protected amorphicService: AmorphicService,
    protected formatterService: FormatterService,
    protected quoteCardService: QuoteCardService
  ) {
    this.controller = amorphicService.controller as Controller;

    this.controller.inviteController.getSafeInviteInfo().then((safeInviteInfo) => {
      this.safeInviteInfo = safeInviteInfo;

      const agent = this.safeInviteInfo.safePolicyInfo.primaryAgent;
      this.advisorFirstName = Utils.toCapitalizedWords(agent.displayName);
      this.advisorLastName = Utils.toCapitalizedWords(agent.lastName);
      this.advisorStreet = agent.street;
      this.advisorCity = agent.city;
      this.advisorState = agent.state;
      this.advisorZipcode = agent.zip;
      this.advisorPhoneLink = agent.phoneNumber;
      this.advisorPhone = this.formatterService.format('telephone', this.advisorPhoneLink);
      this.advisorProducerId = agent.producerId;
      this.advisorAgencyName = agent.agencyName;
      this.yearForIllustration = CoverpathUtils.getCurrentRateYear();
      this.term = this.safeInviteInfo.safePolicyInfo.term;
    });
  }

  async ngOnInit() {
    const customer: CoverpathCustomer = this.customer;
  }

  getBasicIllustrationPdf(): void {
    this.quoteCardService.getBasicIllustrationPdf(false);
  }
}
